/**
 * AMPD DCMS2 — media file value (the string the Media Manager passes to
 * addSelectedFiles() / dcmsMediaInsert())
 *
 * Format: `id;title;att;preview[;license;sizex;sizey]` — fields joined with `;`.
 * Text fields (title, license) are HTML-encoded and a literal `;` in them is
 * written as `&#59;`, so every bare `;` is a separator (PHP side:
 * AMPD\DCMS2\MediaManager\MediaFileValue). The entities themselves end with `;`
 * too, so split() joins back a piece cut at an entity (`&amp`, `&quot`, `&#039`,
 * `&#59`…). Some producers (upload wizard backends) still pass raw text —
 * textToHtml() / toText() handle both.
 *
 * Public API (window.DCMSMediaFileValue):
 *   split(value)      — fields as passed (text fields stay encoded)
 *   parse(value)      — {id, title, att, preview, license, sizeX, sizeY}
 *   encodeText(text)  — a text field for a value built in JS (producers)
 *   toText(text)      — text field (encoded or raw) → plain text
 *   textToHtml(text)  — text field (encoded or raw) → HTML-safe string
 *                       (element content and quoted attributes)
 *   escapeHtml(text)  — plain text → HTML-safe string
 *   version           — API level for feature detection
 */
(function () {
    'use strict';

    if (window.DCMSMediaFileValue) { return; }   // double-include guard (bundle + src)

    /** A piece that ends with an entity whose `;` was taken for a separator. */
    var CUT_ENTITY = /&(?:amp|quot|lt|gt|apos|#0*(?:39|59)|#x0*(?:27|3b))$/i;

    var HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    var TEXT_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;', ';': '&#59;' };

    function str(value) {
        return value == null ? '' : String(value);
    }

    function split(value) {
        var fields = [];
        str(value).split(';').forEach(function (piece) {
            var last = fields.length - 1;
            if (last >= 0 && CUT_ENTITY.test(fields[last])) {
                fields[last] += ';' + piece;
            } else {
                fields.push(piece);
            }
        });
        return fields;
    }

    function parse(value) {
        var f = split(value);
        var n = f.length;
        // Full format: the sizes are always the last two fields, the license is
        // everything between the preview and the sizes
        var full = n >= 7;
        return {
            id: f[0] || '',
            title: f[1] || '',
            att: f[2] || '',
            preview: f[3] || '',
            license: full ? f.slice(4, n - 2).join(';') : (f[4] || ''),
            sizeX: full ? (parseInt(f[n - 2], 10) || 0) : 0,
            sizeY: full ? (parseInt(f[n - 1], 10) || 0) : 0
        };
    }

    function escapeHtml(text) {
        return str(text).replace(/[&<>"']/g, function (ch) { return HTML_ESCAPES[ch]; });
    }

    function encodeText(text) {
        return str(text).replace(/[&<>"';]/g, function (ch) { return TEXT_ESCAPES[ch]; });
    }

    // DOMParser creates an inert document: scripts do not run and resources are
    // not loaded (unlike innerHTML on a detached element)
    function toText(text) {
        var s = str(text);
        if (s.indexOf('&') === -1 && s.indexOf('<') === -1) { return s; }
        return new DOMParser().parseFromString(s, 'text/html').body.textContent || '';
    }

    window.DCMSMediaFileValue = {
        version: 1,
        split: split,
        parse: parse,
        encodeText: encodeText,
        toText: toText,
        textToHtml: function (text) { return escapeHtml(toText(text)); },
        escapeHtml: escapeHtml
    };
})();
